export type Language = 'id' | 'en';

export const LANGUAGES: readonly Language[] = ['id', 'en'];
export const LANGUAGE_DEFAULT: Language = 'id';

// A translated field's suffix per language: `_idn`, since a key ending in `_id`
// reads as a foreign key (#10966 T1). Mirrors the backend's `language_field_name`.
export const LANGUAGE_FIELD_SUFFIXES: Readonly<Record<Language, 'idn' | 'en'>> =
  { id: 'idn', en: 'en' };
